// 在线时长统计设备数据online_account
import request from '@/utils/request';
export function taptapData(data) {
  return request({
    url: '/taptap-data',
    method: 'get',
    params: data
  });
}